import styled from "styled-components";


export default styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr); /* 4 gleich große Spalten */
    gap: 20px; /* Abstand zwischen den Boxen */
    width: 100%; /* Maximale Breite */
    padding: 20px;
`;